const { Skeleton } = require("../../../../components/ui/skeleton");

const LanguageSkeleton = ({ index }) => {
  return (
    <div className="flex flex-col">
      {index === 0 ? (
        <Skeleton className="h-8 w-full rounded-xl mb-2" />
      ) : (
        <div className="h-8 w-full rounded-xl mb-2" />
      )}
      <div className="flex flex-col gap-2 ">
        <Skeleton className=" w-full h-[137px] rounded-xl" />{" "}
      </div>
    </div>
  );
};

export default LanguageSkeleton;
